import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import searchBarsServices from '@src/services/searchBars.servies';

export const getList = createAsyncThunk(
  'admin/searchBarList',
  async ({ body, pageProperty }, { rejectWithValue }) => {
    try {
      return await searchBarsServices.searchBarsGetList(body, pageProperty);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const customerVousGetList = createAsyncThunk(
  'admin/customerVousGetList',
  async ({ body }, { rejectWithValue }) => {
    try {
      return await searchBarsServices.customerVousList(body);
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.data);
    }
  },
);

export const getSearchBarVousOrder = createAsyncThunk(
  'admin/getSearchBarVousOrder',
  async ({ body, params }, { rejectWithValue }) => {
    try {
      return await searchBarsServices.searchBarVousOrderList(body);
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.data);
    }
  },
);

export const updateSearchBarVousOrder = createAsyncThunk(
  'admin/updateSearchBarVousOrder',
  async ({ body, params }, { rejectWithValue }) => {
    try {
      return await searchBarsServices.searchBarVousOrderUpdate(body, params);
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.data);
    }
  },
);

export const getListAdd = createAsyncThunk(
  'admin/searchBarListAdd',
  async ({ body }, { rejectWithValue }) => {
    try {
      return await searchBarsServices.searchBarsAdd(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getListUpdate = createAsyncThunk(
  'admin/searchBarListUpdate',
  async ({ body }, { rejectWithValue }) => {
    try {
      return await searchBarsServices.searchBarsUpdate(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getListDelete = createAsyncThunk(
  'admin/searchBarListDelete',
  async ({ body }, { rejectWithValue }) => {
    try {
      return await searchBarsServices.searchBarsDelete(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const searchBarsSlice = createSlice({
  name: 'serachBars',
  initialState: {
    searchBarList: [],
    pageProperty: { pageNumber: 1, pageSize: 10 },
    customerVous: [],
    vousOrderList: [],
  },

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getList.fulfilled, (state, action) => {
      state.searchBarList = action?.payload?.data?.items;
      state.pageProperty = action?.payload?.data?.pagedProperty;
    });
    builder.addCase(customerVousGetList.fulfilled, (state, action) => {
      state.customerVous = action?.payload?.data;
    });
    builder.addCase(getSearchBarVousOrder.fulfilled, (state, action) => {
      state.vousOrderList = action?.payload?.data;
    });
  },
});
